module.exports = __webpack_public_path__ + "img/chordMate-title.38b60606.png";